import React from "react";
import { Link } from "react-router-dom";
import DefaultData from "../../CompanyData/DefaultData"; // Adjust path if needed
import { useAuth } from "../../Common/Configurations/AuthContext";
const MarketingTabs = (props) => {
  const { user } = useAuth(); // 2. Get user data

  const baseTabStyle = {
    border: "none",
    fontWeight: "500",
    padding: "0.75rem 1.5rem",
    borderRadius: "0.375rem 0.375rem 0 0",
  };

  const inactiveTabStyle = {
    ...baseTabStyle,
    backgroundColor: "transparent",
    color: DefaultData.THEMECOLOR3,
    opacity: 2,
  };

  const activeTabStyle = {
    ...baseTabStyle,
    backgroundColor: DefaultData.THEMECOLOR2, // Dark background
    color: DefaultData.THEMECOLOR3, // White text
  };

  // Helper function to decide which style to apply
  const getStyle = (pageName) => {
    return props.pageName === pageName ? activeTabStyle : inactiveTabStyle;
  };

  const isSupplier = user?.companyType === "SUPPLIER";

  return (
    // The wrapper div with the THEMECOLOR5 background
    <div
      style={{
        backgroundColor: DefaultData.THEMECOLOR5,
        padding: "0 1rem",
        borderBottom: `1px solid ${DefaultData.THEMECOLOR2}`,
      }}
    >
      <ul className="nav nav-tabs" style={{ borderBottom: "none" }}>
        {/* 3. Hide these tabs if user is a SUPPLIER */}

        <>
          <li className="nav-item">
            <Link
              to={"/leaddashboard"}
              className="nav-link"
              style={getStyle("LEADDASHBOARD")}
            >
              LEAD DASHBOARD
            </Link>
          </li>
          <li className="nav-item">
            <Link to={"/leads"} className="nav-link" style={getStyle("LEAD")}>
              LEADS
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to={"/leadcalendar"}
              className="nav-link"
              style={getStyle("APPOINTMENT")}
            >
              APPOINTMENTS
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to={"/marketing"}
              className="nav-link"
              style={getStyle("MARKETING")}
            >
              MARKETING
            </Link>
          </li>
        </>

        {/* 4. PROMOTIONS - Visible to everyone (Suppliers AND others) */}
        <li className="nav-item">
          <Link
            to={"/promotion"}
            className="nav-link"
            style={getStyle("PROMOTION")}
          >
            PROMOTIONS
          </Link>
        </li>

        <>
          <li className="nav-item">
            <Link
              to={"/customers"}
              className="nav-link"
              style={getStyle("CUSTOMERS")}
            >
              CUSTOMERS
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to={"/leadreports"}
              className="nav-link"
              style={getStyle("LEADREPORTS")}
            >
              LEAD REPORTS
            </Link>
          </li>
        </>
      </ul>
    </div>
  );
};

export default MarketingTabs;
